import { fetchFormSubmissions } from "@/api/forms";
import { fetchAllByCursor, fetchAllByPage } from "@/lib/http/fetchAllPages";
import type { FormSubmissionDto } from "@/types/submission";

const SUBMISSIONS_FETCH_PAGE_SIZE = 100;

export type LoadAllSubmissionsOptions = {
  source?: "native" | "yandex";
};

export async function loadAllFormSubmissions(
  formId: number,
  options: LoadAllSubmissionsOptions = {},
): Promise<FormSubmissionDto[]> {
  if (options.source === "yandex") {
    return fetchAllByCursor(
      (nextId, count) =>
        fetchFormSubmissions(formId, { count, nextId }).then((response) => ({
          data: response.data ?? [],
          nextId: response.nextId,
        })),
      SUBMISSIONS_FETCH_PAGE_SIZE,
    );
  }

  return fetchAllByPage(
    (page, count) =>
      fetchFormSubmissions(formId, { page, count }).then(
        (response) => response.data ?? [],
      ),
    SUBMISSIONS_FETCH_PAGE_SIZE,
  );
}
